module.exports = __webpack_public_path__ + "static/reviewer_8-b006c7a0cd933f13435bc5396253aa4a.png";